module.exports = __webpack_public_path__ + "static/media/StoresIcon.28835331.svg";